'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var debug = require('debug')('knack-field-predictor-datetime');
var moment = require('moment-timezone');
var BasePredictor = require('./base.predictor');
var today = moment().format('MM/DD/YYYY');
var any_time_format_regex = new RegExp(/^(00|[0-9]|1[0-9]|2[0-3]):([0-5][0-9]|[0-9])([a|p]m)?$/i);
var evaluations = [{
  criteria: new RegExp(/^(0?[1-9]|1[0-2])(-|\/)(0?[1-9]|[12][0-9]|3[01])(-|\/)\d\d\d\d$/i),
  format: {
    time_type: 'current',
    date_format: 'mm/dd/yyyy',
    default_type: 'current',
    default_date: today,
    time_format: 'Ignore Time',
    calendar: false
  }
}, {
  criteria: new RegExp(/^(0?[1-9]|[12][0-9]|3[01])(-|\/)(0?[1-9]|1[0-2])(-|\/)\d\d\d\d$/i),
  format: {
    time_type: 'current',
    date_format: 'dd/mm/yyyy',
    default_type: 'current',
    default_date: today,
    time_format: 'Ignore Time',
    calendar: false
  }
}, {
  criteria: new RegExp(/^(0?[1-9]|1[0-2])(-|\/)(0?[1-9]|[12][0-9]|3[01])(-|\/)\d\d\d\d (0?[1-9]|1[012])[:| ]?([0-5]\d)\s?([a|p]\.?m\.?)$/i),
  format: {
    default_time: '',
    calendar: false,
    time_format: 'HH:MM am',
    default_date: today,
    default_type: 'current',
    date_format: 'mm/dd/yyyy',
    time_type: 'current'
  }
}, {
  criteria: new RegExp(/^(0?[1-9]|1[0-2])(-|\/)(0?[1-9]|[12][0-9]|3[01])(-|\/)\d\d\d\d ([01]\d|2[0-3])[:| ]?([0-5]\d)$/i),
  format: {
    default_time: '',
    calendar: false,
    time_format: 'HH MM (military)',
    default_date: today,
    default_type: 'current',
    date_format: 'mm/dd/yyyy',
    time_type: 'current'
  }
}, {
  criteria: new RegExp(/^(0?[1-9]|[12][0-9]|3[01])(-|\/)(0?[1-9]|1[0-2])(-|\/)\d\d\d\d (0?[1-9]|1[012])[:| ]?([0-5]\d)\s?([a|p]\.?m\.?)$/i),
  format: {
    default_time: '',
    calendar: false,
    time_format: 'HH:MM am',
    default_date: today,
    default_type: 'current',
    date_format: 'dd/mm/yyyy',
    time_type: 'current'
  }
}, {
  criteria: new RegExp(/^(0?[1-9]|[12][0-9]|3[01])(-|\/)(0?[1-9]|1[0-2])(-|\/)\d\d\d\d ([01]\d|2[0-3])[:| ]?([0-5]\d)$/i),
  format: {
    default_time: '',
    calendar: false,
    time_format: 'HH MM (military)',
    default_date: today,
    default_type: 'current',
    date_format: 'dd/mm/yyyy',
    time_type: 'current'
  }
},
// Time Only
{
  criteria: new RegExp(/^(0?[1-9]|1[012])[:| ]?([0-5]\d)\s?([a|p]\.?m\.?)$/i),
  format: {
    default_time: '',
    calendar: false,
    time_format: 'HH:MM am',
    default_date: today,
    default_type: 'current',
    date_format: 'Ignore Date',
    time_type: 'current'
  }
}, {
  criteria: new RegExp(/^([01]\d|2[0-3])[:| ][0-5]\d$/),
  format: {
    default_time: '',
    calendar: false,
    time_format: 'HH MM (military)',
    default_date: today,
    default_type: 'current',
    date_format: 'Ignore Date',
    time_type: 'current'
  }
}];
var DateTimePredictor = /*#__PURE__*/function (_BasePredictor) {
  function DateTimePredictor() {
    _classCallCheck(this, DateTimePredictor);
    return _callSuper(this, DateTimePredictor, ['date_time']);
  }
  _inherits(DateTimePredictor, _BasePredictor);
  return _createClass(DateTimePredictor, [{
    key: "predict",
    value: function predict(value) {
      var _this = this;
      debug(value);
      var val_from;
      var val_to;
      var splitter = value.includes(' to ') ? ' to ' : value.includes(' - ') ? ' - ' : null;
      if (splitter) {
        debug("We have ".concat(splitter, " in our value, checking for multi/single day DateTime From/To!"));
        var split_value = value.split(splitter);
        debug('split_value:');
        debug(split_value);
        val_from = split_value[0];
        val_to = split_value[1];
      }
      debug("val_from: ".concat(val_from));
      debug("val_to: ".concat(val_to));
      evaluations.forEach(function (evaluation) {
        debug("Criteria: ".concat(evaluation.criteria));
        if (_this.is_match) {
          return;
        }
        debug("Testing regex: ".concat(evaluation));

        // If we split on a to, we need to check for From-To Multi-day and Single day (single day will have val_to being time only)
        // Otherwise just check if the value matches the regex
        if (val_from && val_to && evaluation.criteria.test(val_from) && (evaluation.criteria.test(val_to) || any_time_format_regex.test(val_to))) {
          debug('val_from and val_to passed the regex test!');
          _this.is_match = true;

          // Clone everything from the evaluation but set calendar: true since we are in a from/to situation
          _this.format = _objectSpread(_objectSpread({}, evaluation.format), {}, {
            calendar: true
          });
          return;
        }

        // Simple matching since there is no val_from + val_to
        if (evaluation.criteria.test(value)) {
          debug('the value passed the regex test!');
          _this.is_match = true;
          _this.format = evaluation.format;
          return;
        }
        debug('The regex test did not pass, moving on.');
      });
      return this.prediction;
    }
  }]);
}(BasePredictor);
module.exports = DateTimePredictor;